<template>
  <div id="app-header">
    <div class="top-wrapper"></div>
    <div class="header-wrapper">
      <div class="layout">
        <a
          href="//www.g12e.org"
          target="_blank"
          title="双师教学"
          class="logo"
        ></a>
          <div class="search_hot">
            <span class="title">热门搜索：</span>
            <a
              href="javascript:void(0)"
              @click="jumpToSearch(true,item)"
              v-for="(item,index) in hotList"
              :key="index"
            >{{ item }}</a>
          </div>
          <div class="search">
            <input
              v-model="sKey"
              type="text"
              class="search-content"
              autocomplete="off"
              :placeholder="defaultPlaceholder"
              @keyup.enter="jumpToSearch(false)"
            />
            <button
              class="search-btn"
              @click="jumpToSearch(false)"
            ></button>
          </div>
      </div>
    </div>
  </div>
</template>
<script>
import { $Cookies } from '@/utils';
import { getUserInfo } from '@/api/user';

export default {
  name: 'AppHeader',
  data () {
    return {
      hotList: ['公开课', '选修课', '试题', '教案', '高中数学'],
      defaultPlaceholder: '',
      sKey: '',
      // isLogged: false,
      userName: '',
      nickName: ''
    };
  },
  watch: {
    $route (to) {
      if (to.name === 'SearchList') {
        this.sKey = to.params.key;
      }
    }
  },
  async created () {
    const uid = $Cookies.get('uid');
    const username = $Cookies.get('username');
    if (uid && username) {
      // this.isLogged = true;
      this.userName = username;
    }
    if (uid) {
      await getUserInfo(uid).then(data => {
        this.nickName = data.result.nickName;
      })
    }
  },
  methods: {
    //退出
    logout () {
      const me = this;
      me.$store.dispatch('auth/logout').then(data => {
        if (data.isLogout) {
          me.$message({
            type: 'success',
            message: '退出登录成功',
            duration: 1000,
            onClose: () => {
              window.location.href = '//ssjx.g12e.org';
            }
          });
        }
      });
    },
    jumpToSearch (flag, val) {
      let path = this.$route.path.slice(0, 2);
      const reg = /['";{}()+\-*\/!%#]/;
      let searchKey = '';
      if (reg.test(this.sKey)) {
        this.$message.error('包含特殊字符');
        return false
      }
      if (flag) {
        searchKey = val;
      } else {
        searchKey = this.sKey;
      }
      if (searchKey.trim() !== '') {
        window.open('http://web.g12e.org/s/' + searchKey, '_blank');
      }
    }
  }
};
</script>
